module.exports = __webpack_public_path__ + "img/logo1.528ba28d.png";